module.exports = __webpack_public_path__ + "img/wide.b5e7c406.jpg";